import {
  GET_ALL_ATTACHMENTS_SUCCESS,
  GET_ALL_ATTACHMENTS_LOADING
} from "../actionTypeConstants/Attachments";

const initialState = {
  data: [],
  error: null,
  loading: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_ATTACHMENTS_LOADING:
      return {
        ...state,
        loading: true
      };
    case GET_ALL_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data:
          action.result.data.data !== null ? [...action.result.data.data] : []
      };
    default:
      return state;
  }
}
